import React from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { localStorageKeys } from '../../../lib/localstorageKeys';
import { MultiSelect } from '../../MultiSelect/MultiSelect';
import { TriggerWithChevron } from './TriggerWithChevron';

const displayOptions = [
  {
    value: 'showPositionsInformation',
    label: 'Show Positions Info',
  } as const,
  {
    value: 'showOrderInformation',
    label: 'Show Order Info',
  } as const,
  {
    value: 'showLiquidationPrice',
    label: 'Show Liq. Price',
  } as const,
  {
    value: 'showFills',
    label: 'Show Trade History',
  } as const,
];

type DisplayOptionKey = (typeof displayOptions)[number]['value'];

export const ChartDisplaySettings: React.FC = () => {
  const [showLiquidationPrice, setShowLiquidationPrice] = useLocalStorage(
    localStorageKeys.showLiquidationPrice,
    true
  );
  const [showPositionsInformation, setShowPositionsInformation] = useLocalStorage(
    localStorageKeys.showPositionsInformation,
    true
  );
  const [showOrderInformation, setShowOrderInformation] = useLocalStorage(
    localStorageKeys.showOrderInformation,
    true
  );
  const [showFills, setShowFills] = useLocalStorage(localStorageKeys.showFills, true);

  // Map from value to value and setter
  const settings = {
    showLiquidationPrice: [showLiquidationPrice, setShowLiquidationPrice] as const,
    showPositionsInformation: [showPositionsInformation, setShowPositionsInformation] as const,
    showOrderInformation: [showOrderInformation, setShowOrderInformation] as const,
    showFills: [showFills, setShowFills] as const,
  };

  // Get enabled settings
  const getSelectedValues = (): DisplayOptionKey[] => {
    return Object.entries(settings)
      .filter(([_, [value]]) => value)
      .map(([key]) => key as DisplayOptionKey);
  };

  // Update enabled settings
  const handleChange = (values: DisplayOptionKey[]) => {
    Object.entries(settings).forEach(([key, [_, setter]]) => {
      setter(values.includes(key as DisplayOptionKey));
    });
  };

  return (
    <MultiSelect
      multiselect
      options={displayOptions}
      values={getSelectedValues()}
      onChange={handleChange}
      triggerComponent={({ disabled, ref, isOpen, ...props }) => (
        <TriggerWithChevron
          ref={ref}
          disabled={disabled}
          isOpen={isOpen}
          title="Display Settings"
          {...props}
        >
          Display
        </TriggerWithChevron>
      )}
      optionClassName="flex-row-reverse"
      triggerLabel="Display"
      showSearchInput={false}
    />
  );
};
